
















































































































import HelpPage from './pages/Help.vue'
import AboutPage from './pages/About.vue'
import OptionsPage from './pages/Options/index.vue'
import ContentPage from './pages/ExtraContent/index.vue'
import activePilot from '../pilot_management/mixins/activePilot'

import PilotMode from './modes/pilot.vue'
import EncounterMode from './modes/encounter.vue'
import CompendiumMode from './modes/compendium.vue'

import vueMixins from '@/util/vueMixins'
import { getModule } from 'vuex-module-decorators'
import { NavStore } from '@/store'

export default vueMixins(activePilot).extend({
  name: 'cc-nav',
  components: {
    HelpPage,
    AboutPage,
    OptionsPage,
    ContentPage,
    PilotMode,
    EncounterMode,
    CompendiumMode,
  },
  props: {
    pilotManagement: { type: Boolean },
    encounter: { type: Boolean },
  },
  data: () => ({
    aboutDialog: false,
    helpDialog: false,
    optionsDialog: false,
  }),
  computed: {
    mode(): string {
      return getModule(NavStore, this.$store).NavMode
    },
  },
  methods: {
    home() {
      this.$router.push('/')
    },
    historyNav(dir: number) {
      this.$router.go(dir)
    },
  },
})
